/* ============================================================
   20260820 テーマ見直し — 共通カスタムスクリプト
   1. ヘッダーのスクロール挙動（透過 / #5E5E5E / ハイド）
   2. スライドショーの高さ自動調整（画像を見切れさせない）
   3. メガメニューのホバー展開
   4. 商品カルーセルのマウスドラッグ
   ============================================================ */
(function () {
  'use strict';

  /* rAF スロットは呼び出し元ごとに持たせる。
     共有すると、ヘッダー更新とスライドショー高さ更新が互いのフレームを
     打ち消し合って更新が抜け落ちるため。 */
  function throttled(fn) {
    var rafId = null;
    return function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        fn();
      });
    };
  }

  /* ----------------------------------------------------------
     1. HEADER
     ---------------------------------------------------------- */
  function initHeader() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;

    // スライドショーはヘッダーに重ねない。hero はハイド判定にのみ使う。
    var hero = document.querySelector('[data-pl-hero]');
    var headerHeight = 0;

    function measure() {
      headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--pl-header-height', headerHeight + 'px');
    }

    function isLocked() {
      // メニュー・検索・ドロワーが開いている間はハイドしない
      return !!header.querySelector('details[open]');
    }

    function update() {
      // ヘッダーの背景は常に #121212（透過なし・スライドショーとは重ねない）

      /* --- スライドショーが見えなくなったらハイド --- */
      if (!hero) return;

      var y = window.pageYOffset || document.documentElement.scrollTop;
      var rect = hero.getBoundingClientRect();
      // 最上部では必ず表示。スライドショーがヘッダーの下に隠れきったらハイド。
      var heroVisible = y <= 4 || rect.bottom > headerHeight;

      if (!heroVisible && !isLocked()) {
        header.classList.add('pl-header--hidden');
      } else {
        header.classList.remove('pl-header--hidden');
      }
    }

    measure();
    update();

    var onScroll = throttled(update);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      update();
    });
    header.addEventListener('toggle', update, true);

    // 画像読み込みでヘッダー高さ / スライドショー高さが変わるので追従する
    window.addEventListener('load', function () {
      measure();
      update();
    });
    window.setTimeout(function () { measure(); update(); }, 120);
    window.setTimeout(function () { measure(); update(); }, 600);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        measure();
        update();
      });
      ro.observe(header);
      if (hero) ro.observe(hero);
    }
  }

  /* ----------------------------------------------------------
     2. SLIDESHOW — 画像を見切れさせない
     ---------------------------------------------------------- */
  function initSlideshow() {
    document.querySelectorAll('slideshow-component').forEach(function (comp) {
      var slider = comp.querySelector('[id^="Slider-"]');
      if (!slider) return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('.slideshow__slide'));
      if (!slides.length) return;

      var ratios = slides.map(function (slide) {
        var r = parseFloat(slide.getAttribute('data-pl-aspect'));
        return r && r > 0 ? r : 16 / 9;
      });

      function apply() {
        var width = slider.clientWidth;
        if (!width) return;
        var index = Math.round(slider.scrollLeft / width);
        if (index < 0) index = 0;
        if (index > ratios.length - 1) index = ratios.length - 1;

        var height = width / ratios[index];
        // 正方形など縦長の画像でヒーローが巨大にならないよう画面高さで頭打ちにする。
        // object-fit: contain なので、頭打ちになっても画像が見切れることはない。
        var maxHeight = Math.max(320, window.innerHeight * 0.86);
        if (height > maxHeight) height = maxHeight;
        slider.style.height = Math.round(height) + 'px';
      }

      var applyThrottled = throttled(apply);
      comp.addEventListener('slideChanged', apply);
      slider.addEventListener('scroll', applyThrottled, { passive: true });
      window.addEventListener('resize', applyThrottled);
      apply();
      // 初期レイアウト確定後にもう一度
      window.setTimeout(apply, 60);
      window.addEventListener('load', apply);
    });
  }

  /* ----------------------------------------------------------
     3. ヘッダーメニューの折りたたみ
        メニュー・ロゴ・アイコンが1行に収まらない幅では
        メニューをハンバーガー（ドロワー）に切り替える
     ---------------------------------------------------------- */
  function initNavFit() {
    var headerEl = document.querySelector('.header');
    if (!headerEl) return;

    var nav = headerEl.querySelector('.header__inline-menu');
    var logo = headerEl.querySelector('.header__heading-link');
    var icons = headerEl.querySelector('.header__icons');
    if (!nav || !logo) return;

    function fit() {
      if (window.innerWidth < 990) {
        // 990px 未満はテーマ標準でドロワー表示になる
        headerEl.classList.remove('pl-nav-collapsed');
        return;
      }

      // 折りたたみ中でも実幅が測れるよう、一瞬だけ計測用の状態にする
      headerEl.classList.add('pl-nav-measuring');
      var needed = nav.offsetWidth;
      headerEl.classList.remove('pl-nav-measuring');

      var iconsWidth = icons ? icons.offsetWidth : 0;

      // ロゴを中央に保つ限り、メニューが使えるのは「中身の幅の半分」まで。
      // clientWidth は padding を含むため、実際のコンテンツ幅を出して判定する。
      var cs = window.getComputedStyle(headerEl);
      var contentWidth =
        headerEl.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var gap = parseFloat(cs.columnGap) || 0;
      var sideWidth = (contentWidth - logo.offsetWidth - gap * 2) / 2 - 4;

      headerEl.classList.toggle(
        'pl-nav-collapsed',
        needed > sideWidth || iconsWidth > sideWidth
      );
    }

    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    window.setTimeout(fit, 200);
    window.setTimeout(fit, 800);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* ----------------------------------------------------------
     4. MEGA MENU — デスクトップはホバーで展開
     ---------------------------------------------------------- */
  function initMegaMenu() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');

    // メニュー項目とメガメニュー本体の間には余白があり、
    // そこをマウスが通過すると mouseleave が発火してしまう。
    // 即座に閉じずに猶予を設け、パネルに入ったらキャンセルする。
    var CLOSE_DELAY = 260;
    var closeTimer = null;

    function cancelClose() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeDetails(details) {
      details.removeAttribute('open');
      var s = details.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose(details) {
      cancelClose();
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        closeDetails(details);
      }, CLOSE_DELAY);
    }

    function closeAll(except) {
      nav.querySelectorAll('details[open]').forEach(function (d) {
        if (d === except) return;
        closeDetails(d);
      });
    }

    nav.querySelectorAll('details-disclosure').forEach(function (disclosure) {
      var details = disclosure.querySelector('details');
      var summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      var panel = details.querySelector('.mega-menu');

      function open() {
        if (!mq.matches) return;
        cancelClose();
        closeAll(details);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }

      function leave() {
        if (!mq.matches) return;
        scheduleClose(details);
      }

      disclosure.addEventListener('mouseenter', open);
      disclosure.addEventListener('mouseleave', leave);

      if (panel) {
        // パネル上に入ったら閉じない（クリックできるようにする）
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', leave);
      }
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        cancelClose();
        closeAll(null);
      }
    });
  }

  /* ----------------------------------------------------------
     5. CAROUSEL — マウスドラッグで左右移動
     ---------------------------------------------------------- */
  function makeDraggable(track) {
    if (!track || track.dataset.plDragReady === 'true') return;
    track.dataset.plDragReady = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // タッチはネイティブスクロールに任せる
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (!moved && Math.abs(delta) > 4) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) {
        e.preventDefault();
        track.scrollLeft = startScroll - delta;
      }
    });

    function release(e) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      if (e && e.pointerId != null && track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      if (moved) {
        // ドラッグ直後のクリックを打ち消す
        var swallow = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        track.addEventListener('click', swallow, { capture: true, once: true });
        window.setTimeout(function () {
          track.removeEventListener('click', swallow, true);
        }, 0);
      }
      moved = false;
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('pointerleave', release);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initCarousels() {
    document.querySelectorAll('.pl-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.pl-carousel__track');
      if (!track) return;
      makeDraggable(track);

      // 商品数が表示枚数以下でスクロールできない場合は矢印を隠す
      var navs = carousel.querySelectorAll('.pl-carousel__nav');
      function toggleNav() {
        var scrollable = track.scrollWidth - track.clientWidth > 2;
        navs.forEach(function (b) {
          b.style.display = scrollable ? '' : 'none';
        });
      }
      toggleNav();
      window.addEventListener('resize', toggleNav);
      window.addEventListener('load', toggleNav);
      window.setTimeout(toggleNav, 200);
      window.setTimeout(toggleNav, 800);
      if (window.ResizeObserver) {
        // 参照を保持しないと GC される可能性があるため要素に持たせる
        carousel._plNavObserver = new ResizeObserver(toggleNav);
        carousel._plNavObserver.observe(track);
      }
    });
  }

  /* ---------------------------------------------------------- */
  function boot() {
    initHeader();
    initSlideshow();
    initNavFit();
    initMegaMenu();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // テーマエディタでセクションを再描画したとき
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });
})();
